import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  loading: false,
  event: null,
  error: null,
}

// mutations
export const mutations = {
  [types.EVENT_STATUS_UPDATE_START] (state) {
    state.loading = true
    state.event = null
    state.error = null
  },

  [types.EVENT_STATUS_UPDATE_SUCCESS] (state, { data }) {
    state.loading = false
    state.event = data
    state.error = null
  },

  [types.EVENT_STATUS_UPDATE_ERROR] (state, { error }) {
    state.loading = false
    state.event = null
    state.error = error
  },
}

export const actions = {
  async eventStatusUpdate ({ commit }, { url, params }) {
    try {
      commit(types.EVENT_STATUS_UPDATE_START)

      const { data } = await axios.patch(`${url}`, params)

      commit(types.EVENT_STATUS_UPDATE_SUCCESS, { data: data })
    } catch (e) {
      commit(types.EVENT_STATUS_UPDATE_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingEventStatusUpdate: state => state.loading,
  eventStatus: state => state.event,
  errorEventStatusUpdate: state => state.error,
}
